import React from 'react';

import LabeledInput from '../../components/forms/LabeledInput'
import {reduxForm} from 'redux-form'

import Column, * as ColumnSizes from '../../components/Column'
import ColumnWrapper from '../../components/ColumnWrapper'
import {validateCommissionForm} from "../../util/validate";

function AffiliateCodeForm(props) {

    return (
        <ColumnWrapper>
            <Column columnWidth={ColumnSizes.SIZE_100}>
                <p className="clientdata-step__commission__info">Du bist an uns vermittelt worden oder wirst in Sachen Hosting durch einen Dienstleister unterstützt? Dann gib bitte hier die Mittwald Betreuer-ID der Agentur oder des Freelancers an. Auf Wunsch kannst du später im Kundencenter auch eine Agentur oder einen Freelancer als technischen Betreuer hinterlegen, ihm damit eine Verwaltungsfreigabe für alle technischen Angelegenheiten deines Webprojektes erteilen und dich selbst entspannt zurücklehnen.</p>
                <form onSubmit={(e) => e.preventDefault()} className="clientdata-step__commission">
                    <LabeledInput
                        hint=""
                        fieldId="commission"
                        label=""
                        placeholder="Mittwald Betreuer-ID eingeben"
                        disabled={props.disabled}
                        forceValidation={props.forceValidation}
                    />
                </form>
            </Column>
        </ColumnWrapper>

    )
}

AffiliateCodeForm.propTypes = {};


export default reduxForm({form: 'commissionForm', destroyOnUnmount: false, validate: validateCommissionForm})(AffiliateCodeForm)



/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/AffiliateCodeForm.js
 **/